import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AbstractToggleSignalInput } from '../abstract-toggle-signal-input.component';

@Component({
  selector: 'shared-ui-switch',
  imports: [FormsModule, NgClass, NgTemplateOutlet],
  templateUrl: './switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchComponent extends AbstractToggleSignalInput {
  readonly changed = output<boolean>();

  override toggle(): void {
    const previousValue = this.checked();

    super.toggle();

    if (previousValue !== this.checked()) {
      this.changed.emit(this.checked());
    }
  }
}
